import { Link } from "react-router-dom";
import { MessageCircle, ArrowLeft } from "lucide-react";
import { Button } from "../components/ui/button";

export default function Privacy() {
  return (
    <div className="min-h-screen bg-background">
      <header className="sticky top-0 z-50 w-full border-b border-border bg-background/95 backdrop-blur">
        <div className="max-w-4xl mx-auto px-6 h-16 flex items-center gap-4">
          <Link to="/">
            <Button variant="ghost" size="icon" className="h-8 w-8">
              <ArrowLeft className="w-4 h-4" />
            </Button>
          </Link>
          <Link to="/" className="flex items-center gap-2">
            <img src="/brand/bicarra-icon.svg" alt="Bicarra" className="w-8 h-8 rounded-lg" />
            <span className="font-bold text-xl tracking-tight">BICARRA</span>
          </Link>
        </div>
      </header>

      <main className="max-w-4xl mx-auto px-6 py-12" data-testid="privacy-page">
        <h1 className="text-3xl font-bold tracking-tight mb-8">Privacy Policy</h1>
        
        <div className="prose prose-neutral max-w-none space-y-6">
          <p className="text-muted-foreground">Last updated: September 21, 2026</p>

          <section className="space-y-4">
            <h2 className="text-xl font-semibold">1. Information We Collect</h2>
            <p className="text-muted-foreground">
              We collect information you provide directly to us, such as when you create an account, create chatbots, or contact us for support. This includes your name, email address, and any training data you upload.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-xl font-semibold">2. How We Use Information</h2>
            <p className="text-muted-foreground">
              We use the information we collect to provide, maintain, and improve our services, process transactions, send notifications, and respond to your requests.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-xl font-semibold">3. Data Storage and Security</h2>
            <p className="text-muted-foreground">
              We implement appropriate security measures to protect your personal information. API keys are encrypted using AES-256-GCM encryption. All data is transmitted over HTTPS with TLS 1.2+.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-xl font-semibold">4. Data Retention</h2>
            <p className="text-muted-foreground">
              We retain your information for as long as your account is active or as needed to provide services. You can request deletion of your account and associated data at any time.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-xl font-semibold">5. Third-Party Services</h2>
            <p className="text-muted-foreground">
              Our service integrates with third-party LLM providers (OpenAI, Anthropic, Google, etc.). When you use these integrations, your data is processed according to their respective privacy policies.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-xl font-semibold">6. Website Analytics and Visitor Tracking</h2>
            <p className="text-muted-foreground">
              On our own website we use a third-party visitor tracking service (VisitorTracking) to understand which organisations visit our pages and which content is read. It uses cookies and IP-based lookup, which can identify the company a visitor is connecting from. It does not identify individuals by name, and it is not used inside your chatbot or applied to your customers' conversations.
            </p>
            <p className="text-muted-foreground">
              You can block this by using your browser's tracking protection or an ad blocker. Doing so does not affect your use of the product.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-xl font-semibold">7. Your Rights</h2>
            <p className="text-muted-foreground">
              You have the right to access, correct, or delete your personal information. You can manage your data through your account settings or by contacting us directly.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-xl font-semibold">8. Contact</h2>
            <p className="text-muted-foreground">
              If you have questions about this Privacy Policy, please contact us at privacy@bicarra.com
            </p>
          </section>
        </div>
      </main>
    </div>
  );
}
